import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { PlanningCoach } from '../../../typings';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
     selector: 'app-coach-picker',
     templateUrl: './coach-picker.component.html',
     styleUrls: ['./coach-picker.component.scss'],
})
export class CoachPickerComponent implements AfterViewInit, OnInit {
     _selectedCoaches: Array<number> = [];
     planningCoachList: PlanningCoach[] = [];

     constructor(
          private dialogRef: MatDialogRef<CoachPickerComponent>,
          @Inject(MAT_DIALOG_DATA)
          public data: {
               selectedCoaches: Array<number>;
               coachList: PlanningCoach[];
          }
     ) {
          this.planningCoachList = [].concat(data.coachList || []);
          this._selectedCoaches = [].concat(data.selectedCoaches || []);
     }

     ngAfterViewInit() {}

     ngOnInit() {}

     close() {
          this.dialogRef.close();
     }

     applySelection() {
          const selectedCoaches = this.planningCoachList.filter(
               (r) => this._selectedCoaches.indexOf(r.id) >= 0
          );
          this.dialogRef.close([].concat(selectedCoaches));
     }

     toggleSelection(selection: PlanningCoach) {
          const selectionPos = this.getSelectionPos(selection.id);
          if (selectionPos >= 0) {
               this._selectedCoaches.splice(selectionPos, 1);
          } else {
               this._selectedCoaches.push(selection.id);
          }
     }

     getSelectionPos(selection) {
          return this._selectedCoaches.indexOf(selection);
     }

     reset() {
          this._selectedCoaches = [];
     }
}
